import i18n from 'modules/core/lib/i18n'

export const translations = () => ({
  header: i18n.t('contract_versions.flows.request_promote.steps.dates.header'),
  effective_date: i18n.t('contract_versions.flows.promote.steps.dates.effective_date.label'),
  effective_date_tooltip: i18n.t(
    'contract_versions.flows.promote.steps.dates.effective_date.tooltip'
  ),
  promotion_details: i18n.t(
    'contract_versions.flows.request_promote.steps.dates.promotion_details.label'
  ),
})
